import React, { useEffect, useState } from "react";
import PieChart from ".";
import useApi from "../../../../Hooks/useApi";
import { fetchPieChartData } from "./Utils";
import EmptyChart from "../EmptyChart";
import LoadingSpinner from "../../../Shared/LoadingSpinner";

// Module-level so the reference is stable across renders (avoids
// re-running the fetch effect every render).
const colors = [
  "#003f5c", "#2f4b7c", "#665191", "#a05195",
  "#d45087", "#f95d6a", "#ff7c43", "#ffa600",
];

const PieChartContainer = ({ qus, containerClassName, exportRef, selectedCity, selectedYear }) => {
  // State
  const [pieData, setPieData] = useState([]);
  const [totalValue, setTotalValue] = useState(0);
  const [error, setError] = useState(null); // New Error State

  const { loading, request } = useApi({ isPublic: true });

  useEffect(() => {
 
    setPieData([]);
    setTotalValue(0);
    setError(null);

 
    if (!selectedCity?.id || !qus?.name) {
      return; 
    }

    const fetchData = async () => {
      try {
        const result = await fetchPieChartData(request, {
          location: selectedCity?.id,
          query: qus?.name,
          year: selectedYear
        });

        
        if (!result) {
          throw new Error("Received empty response from server");
        }


        if (!Array.isArray(result.data)) {
       
          console.warn("PieChart: result.data is not an array", result);
          setPieData([]); 
          return;
        }

        setTotalValue(result.total || 0);

     
        const cleanedData = result.data
          .filter((d) => {

            if (!d || !d.name) return false;
            const name = String(d.name).trim().toLowerCase();
            return name !== "null"  && name !== null && name !== "undefined";
          })
          .map((d) => ({
            name: d.name ? String(d.name).trim() : "N/A",
            value: Number(d.value) || 0,
          }));

        const sortedData = cleanedData.sort((a, b) => {
          if (a.name === "N/A") return 1;
          if (b.name === "N/A") return -1;
          return 0;
        });

        const updatedData = sortedData.map((d, index) => ({
          ...d,
    
          color: colors[index % colors.length], 
        }));

        setPieData(updatedData);

      } catch (err) {
        console.error("PieChart Error:", err);
        setError("Unable to load chart data.");
      }
    };

    fetchData();
  }, [selectedCity, qus, request, selectedYear]); 



  if (loading) {
    return <LoadingSpinner message="Loading Pie Chart..." />;
  }

  if (error) {
    return (
      <div className="flex flex-col justify-center items-center h-[300px] border border-red-200 bg-red-50 rounded">
        <p className="text-red-500 font-semibold">{error}</p>
      </div>
    );
  }


  if (!pieData || pieData.length === 0 || totalValue === 0) {
    return <EmptyChart />;
  }

  return (
    <PieChart
      width={550}
      height={550}
      data={pieData}
      totalValue={totalValue}
      containerClassName={containerClassName}
      exportRef={exportRef}
      selectedCity={selectedCity}
      datasetName={qus?.name || "N/A"}
      year={selectedYear}
    />
  );
};

export default PieChartContainer;